import type { UseDeviceCallLogPageOutput } from '../../pages/device-call-log-page/useDeviceCallLogPage.vm';

export enum CallLogInformationSeverity {
  Warning = 'Warning',
  Error = 'Error',
  Info = 'Info',
}

export interface LogMsgRow {
  readonly severity?: CallLogInformationSeverity;
  readonly prefix?: string;
  readonly message: string;
}

export interface CallLogInformationProps extends Pick<UseDeviceCallLogPageOutput, 't'> {
  readonly logLines?: string[];
  readonly shouldHighlightSeverity?: boolean;
}
